import React from "react";
import {
  Button,
  ImageBoxOne,
  SecTitle,
  SecSubTitle,
  InfoMedia,
} from "../../components";

const AboutOne = ({ className }) => (
  <div className={`position-relative ${className || ""}`}>
    <div className="about-shape1 d-none d-xl-block">TechAyukta</div>
    <div className="container z-index-common">
      <div className="row gx-60">
        <div className="col-lg-6 col-xl-5 mb-50 mb-lg-0">
          <ImageBoxOne
            imageOne="images/about/ab-1-1.jpg"
            imageTwo="images/about/ab-1-2.jpg"
            // video="https://www.dropbox.com/s/b4k0p5swok5l8t2/videoplayback.mp4?dl=1"
          />
        </div>
        <div className="col-lg-6 col-xl-7 align-self-center">
          <SecSubTitle>
            <i className="fas fa-graduation-cap" /> SAP Training & Skill
            Development
          </SecSubTitle>
          <SecTitle className="h1">
            Master Every SAP Module — Anytime, Anywhere
          </SecTitle>
          <p className="mb-4 mt-1 pb-3">
            At <strong>NEXTREVOL SOLUTIONES</strong>, We Are Pleased to Offer a
            Full Spectrum of SAP Training Services Designed to Empower
            Individuals and Organizations With the Skills Needed to Thrive in
            Today’s Competitive Enterprise Landscape. Our Training Programs
            Cover All SAP Modules, Delivered by Certified and Experienced
            Trainers.
          </p>
          <p className="mb-4 mt-1 pb-3">
            Gain the skills top employers demand and accelerate your SAP career
            with practical, certification-oriented learning.
          </p>
          <InfoMedia
            image="images/icon/tel-1-1.png"
            title="Professional Guidance & 24/7 Support"
            info="Call Us: +(91) 9167195907"
            className="call-media"
          />
          <Button path="/contact">
            Enroll Now <i className="far fa-long-arrow-right" />
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default AboutOne;
